const storageKey = "digital-twin:admin-sidebar:buildings-expanded"

const storedExpandedState = () => {
  try {
    const value = window.localStorage.getItem(storageKey)
    if (value === null) return null
    return value === "true"
  } catch (_error) {
    return null
  }
}

const storeExpandedState = (expanded) => {
  try {
    window.localStorage.setItem(storageKey, expanded ? "true" : "false")
  } catch (_error) {
    // Ignore storage failures; the toggle should still work for this page.
  }
}

export const mountAdminSidebar = () => {
  document.querySelectorAll('[data-admin-nav-group="buildings"]').forEach((group) => {
    if (group.dataset.adminNavMounted === "true") return

    const toggle = group.querySelector("[data-admin-nav-toggle]")
    if (!toggle) return

    group.dataset.adminNavMounted = "true"

    const setExpanded = (expanded, { persist = true } = {}) => {
      group.classList.toggle("is-expanded", expanded)
      toggle.setAttribute("aria-expanded", expanded ? "true" : "false")
      toggle.setAttribute("aria-label", expanded ? "Collapse buildings menu" : "Expand buildings menu")
      if (persist) storeExpandedState(expanded)
    }

    const defaultExpanded = group.dataset.adminNavDefaultExpanded === "true"
    const storedExpanded = storedExpandedState()
    setExpanded(storedExpanded ?? defaultExpanded, { persist: false })

    toggle.addEventListener("click", (event) => {
      event.preventDefault()
      event.stopPropagation()
      setExpanded(!group.classList.contains("is-expanded"))
    })
  })
}
